import React, { useEffect, useState } from 'react';
import { generateSectionsIcons } from './constants';
import { useNavigate, useParams } from 'react-router-dom';
import { Image } from 'antd';
import { getYachtData } from '../lib/api';
import Banner from './Banner';
import GuestAccommodation from './GuestAccommodation';
import SocialAreas from './SocialAreas';
import YachtItineraries from './YachtItineraries';
import DecksPlan from './DecksPlan';
import SpecsAccordion from './SpecsAccordion';

const Yacht = () => {

  const { yacht } = useParams();

  const [yachtData, setYachtData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchYacht = async (code) => {
      if (!code) {
        console.warn('No yacht code provided');
        setYachtData({});
        setError('No se ha proporcionado código de yate');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = await getYachtData(code);
        
        if (data) {
          setYachtData(data);
        } else {
          setYachtData({});
          setError('No se encontraron datos para este yate');
        }
      } catch (error) {
          console.log(error)

        setYachtData({});
        setError('Error al cargar los datos del yate');
      } finally {
        setLoading(false);
      }
    };

    fetchYacht(yacht);
  }, [yacht]);


  const ICONS = generateSectionsIcons(yachtData)

  return (
    <div className="flex flex-col min-h-screen">
      {loading ? (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
          <div className="text-white text-center">
            <div className="mb-4 flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-p-orange"></div>
            </div>
            <p className="text-xl font-semibold">Cargando información de yate...</p>
          </div>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
          <div className="text-white text-center max-w-md">
            <div className="mb-4 text-4xl">⚠️</div>
            <p className="text-xl font-semibold mb-2">Error al cargar</p>
            <p className="text-gray-300 mb-6">{error}</p>
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2 bg-p-orange text-white rounded-lg hover:bg-p-orange/80 transition-colors"
            >
              Volver Atrás
            </button>
          </div>
        </div>
      ) : (
        <>
          <Banner state={yachtData} />

          {/* Seccion iconos */}
          <div className="w-full bg-p-beige">
            <div className="grid md:w-7xl my-12 mx-auto grid-cols-2 md:grid-cols-4 md:gap-8 text-center">
              {
                ICONS.map((icon, index) => (
                  <div key={index} className="flex flex-col items-center group">
                    <div className="w-20 h-20 flex items-center justify-center mb-3 transition-transform duration-300 group-hover:scale-110">
                      <Image
                        src={icon.image}
                        alt={icon.label}
                        width={icon.size.width}
                        height={icon.size.height}
                        className=' object-cover'
                      />
                    </div>
                    <h4 className="uppercase  text-p-blue max-w-[250px] leading-tight">
                      {icon.label}
                    </h4>
                  </div>
                ))
              }
            </div>
          </div>
          <GuestAccommodation decks={yachtData.decks} />
          <SocialAreas socialAreas={yachtData.social_areas} />
          <YachtItineraries itinerariesRawData={yachtData.itineraries} />
          <DecksPlan decksData={yachtData.deck_plans} />
          <div className='my-5' />
          <SpecsAccordion sections={yachtData.safety} title={'Safety & Communications'} />
          <SpecsAccordion sections={yachtData.mechanic_equipment} title={'Mechanic Equipment'} />
        </>
      )}
    </div >
  );
};


export default Yacht;
